'use client';
import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
var _excluded = ["as", "className", "classPrefix"];
import React from 'react';
import { getWeekStartDates, setDate } from "../internals/utils/date/index.js";
import { useClassNames, useCustom } from "../internals/hooks/index.js";
import Table from "./Table.js";
import { useCalendarContext } from "./CalendarContext.js";
var CalendarBody = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var _props$as = props.as,
    Component = _props$as === void 0 ? 'div' : _props$as,
    className = props.className,
    _props$classPrefix = props.classPrefix,
    classPrefix = _props$classPrefix === void 0 ? 'calendar-body' : _props$classPrefix,
    rest = _objectWithoutPropertiesLoose(props, _excluded);
  var _useCalendarContext = useCalendarContext(),
    _useCalendarContext$d = _useCalendarContext.date,
    date = _useCalendarContext$d === void 0 ? new Date() : _useCalendarContext$d,
    isoWeek = _useCalendarContext.isoWeek,
    overrideLocale = _useCalendarContext.locale,
    weekStart = _useCalendarContext.weekStart;
  var _useCustom = useCustom('Calendar', overrideLocale),
    locale = _useCustom.locale,
    formatDate = _useCustom.formatDate;
  var thisMonthDate = setDate(date, 1);
  var _useClassNames = useClassNames(classPrefix),
    merge = _useClassNames.merge,
    withClassPrefix = _useClassNames.withClassPrefix;
  var classes = merge(className, withClassPrefix());
  return /*#__PURE__*/React.createElement(Component, _extends({}, rest, {
    ref: ref,
    className: classes
  }), /*#__PURE__*/React.createElement(Table, {
    rows: getWeekStartDates(thisMonthDate, {
      isoWeek: isoWeek,
      weekStart: weekStart,
      locale: locale === null || locale === void 0 ? void 0 : locale.dateLocale
    }),
    "aria-label": formatDate(thisMonthDate, locale.formattedMonthPattern)
  }));
});
CalendarBody.displayName = 'CalendarBody';
export default CalendarBody;